<template>
  <div class>
    <SForm
      ref="formref"
      :url="formurl"
      method="post"
      :fields="formfields"
      :dataForm="rowdata"
      :before="formbefore"
      :handle="formhandle"
      labelWidth="150px"
      :inline="false"
      formStyle="width: 400px;"
    >
    </SForm>
  </div>
</template>
<script>
export default {
  name: "reviseAdministrators",
  components: {},
  data() {
    return {
      formurl: "/user",
      rowdata: {},
      formfields: [
        {
          label: "管理员姓名",
          prop: "userName",
          rules: {
            required: true,
            message: "请输入管理员姓名",
            trigger: "blur"
          }
        },
        {
          label: "管理员账号",
          prop: "loginName",
          disabled: true,
          rules: {
            required: true,
            message: "请输入管理员账号",
            trigger: "blur"
          }
        },
        {
          label: "手机",
          prop: "mobile",
          rules: { required: true, message: "请输入手机号", trigger: "blur" }
        },
        {
          label: "密码",
          prop: "password",
          type: "password",
          placeholder: "请输入密码",
          rules: { required: true, message: "请输入密码", trigger: "blur" }
        }
      ],
      formbefore: record => {
        console.log(record);
        let data = {
          id: record.id,
          loginName: record.loginName,
          userName: record.userName,
          mobile: record.mobile,
          password: record.password
        };
        console.log(data);
        return data;
      },
      formhandle: record => {
        this.$router.go(-1);
      }
    };
  },
  computed: {},
  methods: {},
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {
    this.rowdata = this.$route.query.data;
  }, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/BMS/userManagement/reviseAdministrators.vue